import IState from '../state';

const setMealPlan = (state: IState, { mealPlan }: any): IState => ({
  ...state,
  mealPlan,
});

export default setMealPlan;
